'use client';
import style from '@/app/style/servicesetyle.module.css';
import Button from '@/app/btn/page';
import Tick from '../../../../public/updated-home/car-service/city-tours/tick.svg';
import Mydata from '@/app/data/Servies/city_tours.json';
import Image from 'next/image';

function Destination() {
  const data = Mydata[4];
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="">
      <div className={style.updatedcitytours}>
        <div className="mx-auto max-w-7xl pt-12 px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {data.third_trusted.map((item, index) => (
              <div key={index} className="bg-white px-6 pt-4 rounded-xl">
                <div className="flex gap-3">
                  <Image
                    src={item.image}
                    height={30}
                    width={30}
                    alt={item.alt}
                    title={item.tle}
                    className="h-8 w-8"
                  />
                  <h2 className="updatedheading">{item.title}</h2>
                </div>
                <p className="updatedparapremu pb-3 pt-3">{item.des}</p>
              </div>
            ))}
          </div>

          <div className="flex justify-center">
            <button
              onClick={scrollTop}
              className="bg-bb pr-5 pl-5 pt-2 mt-5 pb-2 rounded-2xl mb-3 mt-3"
            >
              BOOK NOW
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Destination;
